import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { MdDashboard, MdOutlineSettings, MdOutlineMenu } from 'react-icons/md'
import { FaTruck, FaX, FaUsers, FaUser } from 'react-icons/fa6'
import { ReactComponent as ProductLogo } from '../../../assets/images/Product_nav.svg'
import { useTranslation } from 'react-i18next'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import { TbBuildingFactory, TbUserSquare } from 'react-icons/tb'
import { ReactComponent as UserLogo } from '../../../assets/images/users.svg'

import { screens, ICON_SIZE } from '../../../utils/constants/UIConstants'
const ATSideNavBar = () => {
  const { t } = useTranslation(['translation'])
  const [isOpen, setIsOpen] = useState(false)

  const navigationMenuItems = [
    {
      path: screens.dashboard,
      name: t('sideMenu.dashboard'),
      icon: <MdDashboard size={ICON_SIZE.L} />,
    },
    {
      path: screens.tenants,
      name: t('sideMenu.tenants'),
      icon: <TbUserSquare size={ICON_SIZE.L} />,
    },
    {
      path: screens.haulers,
      name: t('sideMenu.haulers'),
      icon: <FaTruck size={ICON_SIZE.L} />,
    },
    {
      path: screens.vendors,
      name: t('sideMenu.vendors'),
      icon: <FaUsers size={ICON_SIZE.L} />,
    },
    {
      path: screens.product,
      name: t('sideMenu.product'),
      icon: <ProductLogo />,
    },
    {
      path: screens.customers,
      name: t('sideMenu.customers'),
      icon: <FaUser size={ICON_SIZE.L} />,
    },
    {
      path: screens.plants,
      name: t('sideMenu.plants'),
      icon: <TbBuildingFactory size={ICON_SIZE.L} />,
    },
    {
      path: screens.users,
      name: t('sideMenu.users'),
      icon: <UserLogo />,
    },
    {
      path: screens.settings,
      name: t('sideMenu.settings'),
      icon: <MdOutlineSettings size={ICON_SIZE.L} />,
    },
  ]
  return (
    <div style={{ width: isOpen ? '7vw' : '5vw' }}>
      <div className="toggle-menu text-center pt-4">
        {isOpen ? (
          <FaX className="toggle-menu-icon" onClick={() => setIsOpen(false)} />
        ) : (
          <MdOutlineMenu onClick={() => setIsOpen(true)} size={24} />
        )}
      </div>
      <div className="pt-4">
        {navigationMenuItems.map((item) => {
          return (
            <OverlayTrigger
              key={item.path}
              placement="right"
              overlay={
                <Tooltip id={`tooltip-${item.name}`}>{item.name}</Tooltip>
              }
            >
              <NavLink
                to={item.path}
                key={item.path}
                className={({ isActive }) =>
                  isActive
                    ? `side-bar-menu-container flex-column d-flex navlink-active mt-2`
                    : `side-bar-menu-container flex-column d-flex mt-2`
                }
              >
                <div className="text-center">{item.icon}</div>
                {isOpen && (
                  <div className="side-bar-menu-label text-center">
                    {item.name}
                  </div>
                )}
              </NavLink>
            </OverlayTrigger>
          )
        })}
      </div>
    </div>
  )
}

export default ATSideNavBar
